/** @module Apparel/PrintDesign/PrintPositionColorMatrix */
define([
    "dojo/_base/declare",
    "csi/table/matrix/ColumnAssociation"
], function(declare,ColumnAssociation) {

    return declare(ColumnAssociation, {
        selectedColumnValueProperty: "printDesignColors",
        availableColumnStoreProperty: "printDesignColorsStore",

        shouldRenderLoneSubheader: function(subSpec) {
            var h = subSpec.heading;
            return !(h.m_id === "PrintPositionColorSpecification");
        }
    });
});
